import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "@redux-devtools/extension";
import { thunk } from "redux-thunk";
import rootReducer from "./reducers";
import setAuthToken from "./utils/setAuthToken";
import { authDebug } from "./utils/api";

const initialState = {};

const authDebugMiddleware = store => next => action => {
  const before = store.getState()?.auth || {};
  const result = next(action);
  const after = store.getState()?.auth || {};

  if (action?.type && (
    action.type.includes("AUTH")
    || action.type.includes("LOGIN")
    || action.type.includes("LOGOUT")
    || action.type.includes("USER_LOADED")
    || action.type.includes("PERMISSIONS")
  )) {
    authDebug("redux:auth-action", {
      type: action.type,
      before: {
        authenticated: before.authenticated,
        loading: before.loading,
        hasToken: Boolean(before.token)
      },
      after: {
        authenticated: after.authenticated,
        loading: after.loading,
        hasToken: Boolean(after.token),
        hasUser: Boolean(after.user),
        permissions: after.permissions?.length || 0
      }
    });
  }

  return result;
};

const middleware = [authDebugMiddleware, thunk];

const store = createStore(
  rootReducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);

// set up a store subscription listener
// to store the users token in localStorage

// initialize current state from redux store for subscription comparison
// preventing undefined error
let currentState = store.getState();

store.subscribe(() => {
  // keep track of the previous and current state to compare changes
  let previousState = currentState;
  currentState = store.getState();
  // if the token changes set the value in localStorage and axios headers
  if (previousState.auth.token !== currentState.auth.token) {
    const token = currentState.auth.token;
    authDebug("store:token-change", {
      hadToken: Boolean(previousState.auth.token),
      hasToken: Boolean(token)
    });
    setAuthToken(token);
  }
});

export default store;
